import {
  CreateDraftInvoiceDto,
  CreateInvoiceDto,
  Invoice,
} from "@/features/invoices/types/invoices";
import api from "@/lib/axios";

// Centralized query keys for invoices domain
export enum InvoicesKeys {
  Invoices = "invoices",
  AllowedPaymentMethods = "allowed-payment-methods",
  StripeAccountStatus = "stripe-account-status",
}

export const getStripeAccountStatus = async () => {
  const response = await api.get(`/licensees/stripe-account-status`);
  return response.data;
};

export const getStripeAccountUpdateLink = async (): Promise<{ url: string }> => {
  const response = await api.get(`/licensees/stripe-account-update-link`);
  return response.data;
};

export const getInvoices = async (): Promise<Invoice[]> => {
  const response = await api.get(`/invoices`);
  return response.data;
};

export const createInvoice = async (invoice: CreateInvoiceDto) => {
  const response = await api.post(`/invoices`, invoice);
  return response.data;
};

export const createDraftInvoice = async (invoice: CreateDraftInvoiceDto) => {
  const response = await api.post(`/invoices/draft`, invoice);
  return response.data;
};

export const allowedPaymentMethods = async () => {
  const response = await api.get(`/invoices/allowed-payment-methods`);
  return response.data;
};

export const patchInvoiceHeader = async (
  invoiceId: string,
  data: {
    currency?: string;
    dueDate?: number;
    description?: string;
    paymentMethodTypes?: string[];
    // STA-682: enhanced invoice fields
    poNumber?: string;
    projectName?: string;
    notes?: string;
  }
) => {
  const response = await api.patch(`/invoices/header`, {
    invoiceId,
    ...data,
  });
  return response.data;
};

export const patchInvoiceItem = async (
  invoiceItemId: string,
  data: {
    amountCents?: number;
    description?: string;
  }
) => {
  const response = await api.patch(`/invoices/item`, {
    invoiceItemId,
    ...data,
  });
  return response.data;
};

export const createInvoiceItem = async (data: {
  invoiceId: string;
  amountCents?: number;
  currency: string;
  description?: string;
}) => {
  const response = await api.post(`/invoices/item`, data);
  return response.data;
};

// STA-682: allow the invoice form to remove line items from a draft invoice.
export const deleteInvoiceItem = async (invoiceItemId: string) => {
  const response = await api.delete(`/invoices/item/${invoiceItemId}`);
  return response.data;
};

export const finalizeInvoice = async (invoiceId: string) => {
  const response = await api.post(`/invoices/${invoiceId}/finalize`);
  return response.data;
};

export const getInvoiceDetails = async (invoiceId: string) => {
  const response = await api.get(`/invoices/${invoiceId}`);
  return response.data;
};

export const sendInvoice = async (invoiceId: string) => {
  const response = await api.post(`/invoices/${invoiceId}/send`);
  return response.data;
};

export const voidInvoice = async (invoiceId: string) => {
  const response = await api.post(`/invoices/${invoiceId}/void`);
  return response.data;
};
